import r from "./_cb.js";
import o from "./_getLength.js";
function t(t, e, f, a) {
  for (var n = (f = r(f, a, 1))(e), m = 0, s = o(t); m < s;) {
    var d = Math.floor((m + s) / 2);
    f(t[d]) < n ? m = d + 1 : s = d;
  }
  return m;
}
export { t as default };